import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { appRouteDefinitions, NotFoundPage } from './appNavigation';
import { useUserStore, userSelectors } from '../../entities/user';

interface AppRoutesProps {
  loadingFallback: React.ReactNode;
}

export function AppRoutes({ loadingFallback }: AppRoutesProps) {
  const token = useUserStore(userSelectors.token);

  return (
    <Suspense fallback={loadingFallback}>
      <Routes>
        {appRouteDefinitions.map(
          ({ path, component: Component, requiresAuth }) => (
            <Route
              key={path}
              path={path}
              element={
                requiresAuth && !token ? (
                  <Navigate to="/auth" replace />
                ) : (
                  <Component />
                )
              }
            />
          )
        )}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
